import { useState, useEffect } from "react";

const TopBarLayout = ({ children, className = "" }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={`w-full z-[100] sticky left-0 top-0 bg-white transition-shadow duration-300 ${
        isScrolled ? "shadow-md" : ""
      } ${className}`}
    >
      <div className="w-full max-w-[640px] mx-auto">{children}</div>
    </div>
  );
};

export default TopBarLayout;
